import React, {memo} from "react";
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
import {getSelectedValueBasedOnField, isSet} from '../../../../Utils/CommonFunctions';
import isEqual from 'lodash/isEqual';
import { connect } from "react-redux";

const SubFormItem = (props) => {
  const {
    item,
    modType,
    keyIndex,
    subFormIndex,
    // columnData,
    columnIndex,
    rowIndex,
    pageType,
    subformValidation,
    reminderDisplayText,
    rowId,
    isOpenBox,
    section
  } = props;

  let styles = (item.element === 'CheckBoxes') ? {position: 'relative', top: '-16px'} : {};
  const { reminder,files,selectedValue,selected_value_text,selecteddpnm,overridden,currency_code,options} = props;
  let elementObj = {element_original: item.element};

  if (['PickList', 'MultiSelect', 'User', 'Lookup', 'MultiLookup'].includes(item.element)) {
    elementObj = {
      element: 'CustomAll',
      element_original: item.element,
    };
  }

  if (['ImageUpload', 'FileUpload'].includes(item.element)) {
    elementObj = {
      element: 'CustomAllFiles',
      element_original: item.element,
    };
  }

  // Memoize updatedItem to avoid unnecessary recalculations and re-renders
  // const updatedItem = useMemo(() => ({
  //   ...item,
  //   options: isSet(options, item.options),
  //   reminder,
  //   files,
  //   selectedValue,
  //   selectedValueText: selected_value_text,
  //   displayValue: selecteddpnm,
  //   overridden,
  //   id: `${item.id}_${rowIndex}_${rowId}`,
  //   modType,
  //   currency_code,
  //   ...elementObj
  // }), [item, options, reminder, files, selected_value_text, selecteddpnm, overridden, rowIndex, rowId, modType, currency_code, elementObj]);

  const updatedItem = {
    ...item,
    options: isSet(options, item.options),
    reminder,
    files,
    selectedValue,
    selectedValueText: selected_value_text,
    displayValue: selecteddpnm,
    overridden,
    id: `${item.id}_${rowIndex}_${rowId}`,
    modType,
    currency_code,
    ...elementObj
  };
  const fieldObj = {
    section_index: section.section_index,
    itemIndex: item.itemIndex,
    modType,
    item: updatedItem,
    rowIndex,
    subFormIndex,
    columnIndex
  };
  // console.log('updatedItem');
  return (
    <td key={rowIndex + '_' + keyIndex}>
      {(isOpenBox === true || pageType === 'form') ? (
        <div style={{...styles}}>
          <SwitchItems
            {...props}
            layoutForms={true}
            formType={'SUBFORM'}
            modType={'ADDFORM'}
            fieldObj={fieldObj}
            item={updatedItem}
            reminderDisplayText={reminderDisplayText}
          />
          {isSet(subformValidation[item.id], null) !== null && (
            <div>
              <span className="text-danger m-1">
                {isSet(subformValidation[item.id][rowIndex], '')}
              </span>
            </div>
          )}
        </div>
      ) : getSelectedValueBasedOnField(updatedItem)}
    </td>
  );
};

const isDiffProps = (prevProps, nextProps) => {
  if (
    prevProps.currencyCode === nextProps.currencyCode &&
    isEqual(prevProps.selectedValue, nextProps.selectedValue) &&
    isEqual(prevProps.options, nextProps.options) &&
    prevProps.item.access_mode === nextProps.item.access_mode &&
    prevProps.item.required === nextProps.item.required &&
    prevProps.isOpenBox === nextProps.isOpenBox &&
    isEqual(prevProps.subformValidation[prevProps.item.id], nextProps.subformValidation[nextProps.item.id])
  ) {
    return true; 
  }

  return false; 
};


const mapDispatchToProps = dispatch => {
  return {
    // setSubFormDataAction:(modType,data)=>dispatch(setSubFormDataAction(modType,data)),
    // clearSubformValidation:(modType,row)=>dispatch(clearSubformValidation(modType,row))
  };
}
const mapStateToProps = (state,props) => { 
  return {
      // subformData:state.formBuilder.subformData[props.modType],
      // validationForms:state.formBuilder.validationForms[props.modType],
      // subformData: state.formBuilder.subformData['DETAILVIEW'],
      subformValidation:state.formBuilder.subformValidation[props.modType],
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(memo(SubFormItem,isDiffProps));
// export default (SubFormItem);
